"use client"

import { useState } from "react"
import { Card, CardHeader, CardBody, Button, Alert, Spinner, Row, Col } from "reactstrap"
import { FaEye, FaDownload, FaUser, FaIdCard } from "react-icons/fa"
import { toast } from "react-toastify"
import { BadgeService, type BadgePreviewResponse } from "../../../Service/myBadgeOrderService"
import ProfessionalBadgeDesigner from "./professional-badge-designer"

const MyBadgePreview = () => {
  const [loading, setLoading] = useState(false)
  const [previewData, setPreviewData] = useState<BadgePreviewResponse | null>(null)
  const [showDesigner, setShowDesigner] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handlePreviewBadge = async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await BadgeService.previewMyBadge()
      setPreviewData(response)
      setShowDesigner(true)
      //toast.success("Badge preview loaded successfully!")
    } catch (err: any) {
      console.error("Failed to preview badge:", err)
      const errorMessage = err.response?.data?.message || "Failed to load badge preview"
      setError(errorMessage)
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  const handleCloseDesigner = () => {
    setShowDesigner(false)
  }

  const handleBadgeComplete = (badgeImage: string) => {
    // For preview mode, we just show success message
    //toast.success("Badge preview generated successfully!")
  }

  return (
    <>
      <Card className="shadow-sm">
        <CardHeader className="bg-light">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-0 text-primary">
                <FaEye className="me-2" />
                My Badge Preview
              </h5>
              <small className="text-muted">Preview how your badge will look before printing real one</small>
            </div>
            <Button color="primary" onClick={handlePreviewBadge} disabled={loading}>
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Loading...
                </>
              ) : (
                <>
                 
                  Generate Preview
                </>
              )}
            </Button>
          </div>
        </CardHeader>
        <CardBody>
          {error && (
            <Alert color="danger" className="mb-4">
              <strong>Preview Error:</strong> {error}
            </Alert>
          )}

          {!loading && !error && (
            <div className="text-center py-5">
              <div className="mb-4">
                <FaIdCard size={64} className="text-muted opacity-50" />
              </div>
              <h5 className="text-muted mb-3">Badge Preview</h5>
              <p className="text-muted mb-4">
                Click "Generate Preview" to see how your badge will look with your current profile information.
              </p>
              <div className="bg-dark opacity-60 p-4 rounded">
                <h6 className="text-primary mb-3">Preview Features:</h6>
                <Row>
                  <Col md="6">
                    <ul className="list-unstyled text-start">
                      <li className="mb-2">
                        <FaUser className="me-2 text-success" size={14} />
                        Your current profile information
                      </li>
                      <li className="mb-2">
                        <FaIdCard className="me-2 text-info" size={14} />
                        Professional badge design
                      </li>
                    </ul>
                  </Col>
                  <Col md="6">
                    <ul className="list-unstyled text-start">
                      <li className="mb-2">
                        <FaDownload className="me-2 text-warning" size={14} />
                        Download PNG option
                      </li>
                      <li className="mb-2">
                        <FaEye className="me-2 text-primary" size={14} />
                        No tracking or fees
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </div>
          )}

          {/* {previewData && !showDesigner && (
            <div className="text-center py-4">
              <Alert color="success" className="mb-4">
                <strong>Preview Ready!</strong> Your badge preview has been generated successfully.
              </Alert>
              <div className="bg-primary text-light p-4 rounded mb-4">
                <h6 className="text-secondary mb-3">Preview Information:</h6>
                <Row>
                  <Col md="6">
                    <p className="mb-2">
                      <strong>Name:</strong> {previewData.person_info?.name}
                    </p>
                    <p className="mb-2">
                      <strong>Email:</strong> {previewData.person_info?.email}
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="mb-2">
                      <strong>Phone:</strong> {previewData.person_info?.phone}
                    </p>
                    <p className="mb-2">
                      <strong>Photo:</strong>{" "}
                      <span className={previewData.person_info?.has_photo ? "text-success" : "text-warning"}>
                        {previewData.person_info?.has_photo ? "Available" : "Not Available"}
                      </span>
                    </p>
                  </Col>
                </Row>
              </div>
              <Button color="primary" size="lg" onClick={() => setShowDesigner(true)}>
                <FaEye className="me-2" />
                View Badge Design
              </Button>
            </div>
          )} */}

          {loading && (
            <div className="text-center py-5">
              <Spinner color="primary" size="lg" />
              <p className="mt-3 text-muted">Generating your badge preview...</p>
            </div>
          )}
        </CardBody>
      </Card>

      {/* Badge Designer Modal for Preview */}
      {showDesigner && previewData && (
        <ProfessionalBadgeDesigner
          isOpen={showDesigner}
          onToggle={handleCloseDesigner}
          badgeData={previewData.badge_data}
          templateConfig={previewData.template_config}
          onComplete={handleBadgeComplete}
          isPreviewMode={true} // Add this prop to indicate preview mode
        />
      )}
    </>
  )
}

export default MyBadgePreview
